import { combineReducers } from 'redux';

import globalReducer from './global/globalReducer';
import configReducer from './config/configReducer';
import loginReducer from './login/loginReducer';
import {modalReducer} from 'components/Modal';
import signReducer from './sign/signReducer';
import selfAuthReducer from './self-auth/selfAuthReducer';
const rootReducer = combineReducers({
    global: globalReducer,
    config: configReducer,
    login: loginReducer,
    modal: modalReducer,
    sign: signReducer,
    selfAuth: selfAuthReducer,
});

export default rootReducer;